import { useModalHooks } from "../../../../App/State/Hooks/useModalHooks";
import { ITableColumn } from "../../../../App/Typings/Table";
import {
  useGetAbacAppsQuery,
  useGetUsersForClientQuery,
} from "../../AbacAppQueries";
import useCreateUserFormState from "./CreateUserFormState";

export default function useAbacUserState() {
  const createUserModalTitle = "Create New User";
  const attributeAssignementModalTitle = "Assign App Permissions";

  const { data: apps = [], isLoading } = useGetAbacAppsQuery();
  const { data: users = [], isLoading: usersLoading } =
    useGetUsersForClientQuery();
  const {
    getters: { formik, activeStep, steps },
    handlers: { handleCreateModalClose },
  } = useCreateUserFormState({ isAdminCreation: false });

  const columns: ITableColumn[] = [
    { label: "First Name", propName: "firstName" },
    { label: "Last Name", propName: "lastName" },
    { label: "Email", propName: "emailAddress" },
    { label: "Date Created", propName: "createdDate" },
    { label: "Is Active", propName: "isActive" },
    { label: "", propName: "" },
  ];

  return {
    getters: {
      apps,
      users,
      columns,
      isLoading,
      usersLoading,
      createUserModalTitle,
      attributeAssignementModalTitle,
      formik,
      activeStep,
      steps,
    },
    handlers: { handleCreateModalClose },
  };
}
